import styled from 'styled-components';

export const Container = styled.div`
  .card-title-text {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 28px;
    text-align: center;
    color: ${(props) => props.theme.$primary_green};
  }

  .card-text-subtitle {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
  }

  .card-body {
    text-align: center;
  }
`;
